import React from "react";

const AlignRightIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M18 6h-8m8 4H6m12 4h-8m8 4H6"
      />
    </svg>
  );
};

export default AlignRightIcons;
